import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import Fonts from '@themes/Fonts'

type Props = {
  message: string
  actions?: React.ReactNode
}

export function EmptyView(props: Props) {
  return (
    <View style={styles.container}>
      <Text style={styles.message}>{props.message}</Text>

      <>{props.actions}</>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 22,
  },
  message: {
    fontFamily: Fonts.type.bold,
    fontSize: 22,
    lineHeight: 29,
    marginTop: 67,
    marginBottom: 16,
    textAlign: 'center',
  },
})
